// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__Avice","header":"MergedInvoice_header__2z_rd"};